import styled from '@emotion/styled'
import { Typography } from '@material-ui/core'
import { ManageListItem } from 'components/inputs/ManageListItem/ManageListItem'

const IdText = styled(Typography)`
  width: 52px;
  margin: 5px;
  padding: 16px;
  justify-self: center;
`

interface ManageListItemProps {
  $borderColor: string
}

const StyledManageListItem = styled(ManageListItem)<ManageListItemProps>`
  border-color: ${({ $borderColor }) => $borderColor};
`

export {
  IdText,
  StyledManageListItem as ManageListItem,
}
